var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRequested = function SvgRequested(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm0 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12Zm3.925-6.88a1.06 1.06 0 0 0-.22-.33l-2-2a1 1 0 0 0-1.41 1.41l.29.295H8a4 4 0 0 0-4 4 1 1 0 1 0 2 0 2 2 0 0 1 2-2h.585l-.29.295a1 1 0 1 0 1.41 1.41l2-2a1 1 0 0 0 .22-1.09"
  })));
};
export default SvgRequested;